import React, { useRef } from 'react';
import Card from '../../Card';
import '../Category.css';
import img1 from  "./london-after-dark/London-skyline.webp";
import img2 from  "./thailand-tropical-escape/thailand.webp";
import img3 from  "./japan-cherry-blossom-trails/Mt. Fuji.webp";
import img4 from  './dubai-luxury-adventure/dubai.webp';
import img5 from  "./vietnam-discovery/(8).webp";

// import img3 from  "./bali-island-paradise/Bali.webp";

export const travelBlogs = [
 {
  id: 'london-after-dark',
  title: 'London After Dark: The City That Never Sleeps',
  summary: 'Discover the magic of London after sunset — from glittering skylines and Thames cruises to vibrant street music, hidden pubs, and timeless night charm. Experience the city that truly never sleeps.',
  image: img1, 
},
{
  id: 'thailand-tropical-escape',
  title: 'Thailand: Tropical Paradise Awaits',
  summary: 'From Bangkok’s buzzing streets to Phuket’s golden beaches and Chiang Mai’s serene temples — discover the vibrant culture, exotic flavors, and breathtaking beauty that make Thailand every traveler’s dream.',
  image: img2, 
},
{
  id: 'japan-cherry-blossom-trails',
  title: 'Japan – Cherry Blossom Trails: A Journey Through Sakura Season',
  summary:'Experience Japan at its most magical — wander under pink sakura tunnels, explore Kyoto’s historic temples, admire Tokyo’s vibrant spring gardens, and capture breathtaking cherry blossom views across Japan. Discover the best hanami spots, travel tips, and hidden trails for the ultimate cherry blossom adventure.',
  image: img3, // import your Japan image
},
{
  id: 'dubai-luxury-adventure',
  title: 'Dubai: Luxury, Adventure, and Iconic Wonders',
  summary: 'Experience the allure of Dubai — from soaring skyscrapers like Burj Khalifa to pristine desert safaris, luxurious shopping at Dubai Mall, and world-class beaches. Explore the perfect blend of modern marvels, rich culture, and thrilling adventures that make Dubai a top destination for travelers seeking unforgettable experiences.',
  image: img4, // import your Dubai image like img4 from its path
},
{
  id: 'vietnam-discovery',
  title: 'Vietnam: Hidden Gems & Timeless Journeys',
  summary: 'From Hanoi’s centuries-old streets to Ha Long Bay’s limestone wonders and Hoi An’s lantern-lit alleys — immerse in rich history, unforgettable flavors, and stunning landscapes that make Vietnam a must-visit.',
  image: img5,
},

// {
//   id: 'bali-island-paradise',
//   title: 'Bali Bliss: The Island of Gods and Infinite Beauty',
//   summary: 'Explore Bali — where emerald rice terraces meet turquoise seas, ancient temples whisper stories of peace, and sunsets paint the sky in gold. From Ubud’s jungle retreats to Seminyak’s beach vibes, discover why Bali is the ultimate tropical escape for travelers, honeymooners, and adventure lovers alike.',
//   image: img3,
// }



  // Add more blogs as needed...
];

export default function TravelCategory() {
  const rowRef = useRef(null);

  const scrollLeft = () => {
    rowRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    rowRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    // <div className="category-section">
    //   <h2 className="categoryhead">Beyond Horizons: Global Travel Tales</h2>
    //   <div className="scroll-wrapper">
    //     <button className="scroll-btn left" onClick={scrollLeft}>&lt;</button>
    //     <div className="blog-row-horizontal" ref={rowRef}>
    //       {travelBlogs.map(blog => (
    //         <Card key={blog.id} blog={blog} category="Travelinternational" />
    //       ))}
    //     </div>
    //     <button className="scroll-btn right" onClick={scrollRight}>&gt;</button>
    //   </div>
    // </div>
     <div className="category-section">
      <h2 className="categoryhead">Beyond Horizons: Global Travel Tales</h2>
      <div className="scroll-wrapperr">
        <button className="scroll-btnn l" onClick={scrollLeft}>&lt;</button>
        <div className="blog-row-horizontal" ref={rowRef}>
          {travelBlogs.map(blog => (
            <Card key={blog.id} blog={blog} category="Travelinternational" />
          ))}
        </div>
        <button className="scroll-btnn r" onClick={scrollRight}>&gt;</button>
      </div>
    </div>
  );
}
